module.exports = __webpack_public_path__ + "img/6.7e21922d.png";